import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Backend from '../../../Backend';
import ReactNotification from 'react-notifications-component';
import Connection from '../../../Calls';
import { store } from 'react-notifications-component';

let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
// var HeightScreen = window.screen.height;

class WalletTransactionsCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      search: '',
      orderBySelect: 'Date newest',
      sendOrderBySelect: 'date_new',
      numeroFilas: 5,
      paginaActual: 1,
      walletslistpagination: [],
      dateFrom: '',
      dateTo: '',
    }
  }

  componentDidUpdate() {
    const self = this;
    if (self.props.refresh) {
      self.walletsPagination(1, 5, this.state.sendOrderBySelect);
      this.props.refreshTableTransactions(false);
    }
  }

  componentWillMount() {
    this.walletsPagination(this.state.paginaActual, this.state.numeroFilas, this.state.sendOrderBySelect);
  }

  redirectTransaction() {
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    this.props.redirect.push('/wallets/information/transactions?id=' + idWallet + '&coin=' + this.props.walletsinformation.coin);
  }

  walletsPagination(value_paginaActual, value_numeroFilas, value_orderbyfilter) {
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    self.setState({ showLoad: true, paginaActual: value_paginaActual, numeroFilas: value_numeroFilas, sendOrderBySelect: value_orderbyfilter });
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.WalletsPaginationTransaction(localStorage.getItem('email'), localStorage.getItem('token'), idWallet, value_numeroFilas, value_paginaActual, response.payload.r01, this.state.search, this.state.dateFrom, this.state.dateTo, value_orderbyfilter, response => {
        if (response.status.code === "0") {
          self.setState({
            walletslistpagination: response.payload.transactions_list,
            dataLength: Math.ceil(response.payload.total_amount / value_numeroFilas),
            showLoad: false
          });
        } else {
          self.setState({
            walletslistpagination: [],
            showLoad: false
          });
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });
    });
  }

  renderListWallets() {
    const self = this;
    var users = [];
    self.state.walletslistpagination.forEach(function (row) {
      var mes_actual = meses[row.date.substr(-14, 2) - 1];
      var text_type_transaction;
      var border_type_transaction = row.category.split(" ")[0];

      if (row.category === "deposit") {
        text_type_transaction = <p className="transactions-text-address" style={{ color: "#4EC95E", textTransform: "capitalize" }}>{row.amount}</p>;
      } else if (row.category === "withdrawal") {
        text_type_transaction = <p className="transactions-text-address" style={{ color: "#FB5B5A", textTransform: "capitalize" }}>{row.amount}</p>;
      } else {
        text_type_transaction = <p className="transactions-text-address" style={{ color: "#053064", textTransform: "capitalize" }}>{row.amount}</p>;
      }
      users.push(
        <div className={"container-information-important-transactions border-" + border_type_transaction}>
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div style={{ backgroundColor: "#e7eaf0", padding: "0px 10px", borderRadius: 5, textAlign: "center" }}>
              <p style={{ color: "#0F4C81", marginBottom: -5, fontSize: 18, fontWeight: "bold" }}>{row.date.substr(-11, 2)}</p>
              <p style={{ color: "#0F4C81", marginBottom: 0, fontSize: 15, textTransform: "uppercase" }}>{mes_actual.substr(0, 3)}</p>
            </div>
            <div style={{ width: "100%", padding: 10 }}>
              <p className="transactions-text-address three-dots-txid" style={{ marginBottom: -5 }}>{row.address}</p>
              <p className="transactions-text-date">{row.category}</p>
            </div>
            <div style={{ textAlign: "right" }}>
              {text_type_transaction}
            </div>
          </div>
        </div>
      );
    });
    return users;
  }

  render() {
    return (
      <div className="container-shadow-card-wallets-information">
        <div className="border-title-separator-container">
          <div className="border-title-separator-container-left">
            <p className="title-container-shadow">{this.props.traductions.wallets.overview.Transactions}</p>
          </div>
          <div className="border-title-separator-container-right">
            <Button className="subtitle-container-shadow link-transactions" variant="link" onClick={() => { this.redirectTransaction() }}>{this.props.traductions.wallets.overview.seeMore}</Button>
          </div>
        </div>

        <div className="scrollbar-transactions-important" style={{ height: "calc(100vh - 670px)" }}>
          {this.renderListWallets()}
        </div>
        
      </div>
    );
  }
} export default WalletTransactionsCard;
